export const getAuthConfirmationUrl = () => {
  if (typeof window === 'undefined') return ''
  const origin = window.location.origin

  return `${origin}/api/auth/confirm`
}

export const publicRoutes = [
  '/login',
  '/pass-reset',
  '/auth-pages/pass-reset',
  '/error',
  '/404',
]

export const protectedRoutes = ['/onboarding', '/pass-setup']

export const landingRoutes = ['/auth-pages/verify', '/verify']

export const root = '/'

export const isRootRoute = (path: string) => path === root

export const isPublicRoute = (path: string) => publicRoutes.includes(path)

export const isProtectedRoute = (path: string) => protectedRoutes.includes(path)

export const isPrivateRoute = (path: string) =>
  !!path &&
  !isPublicRoute(path) &&
  !isProtectedRoute(path) &&
  !isLandingRoute(path)

export const isLandingRoute = (path: string | undefined) =>
  !!path &&
  landingRoutes.some(route => path === route || path.startsWith(route))
